const oktaAuthConfig = {
  // Note: If your app is configured to use the Implicit Flow
  // instead of the Authorization Code with Proof of Code Key Exchange (PKCE)
  // you will need to add `pkce: false`
  issuer:  process.env.REACT_APP_OKTA_BASE_URL + '/oauth2/' + process.env.REACT_APP_OKTA_AUTH_SERVER_ID, 
  clientId: process.env.REACT_APP_OKTA_CLIENTID,
  redirectUri: window.location.origin + '/login/callback'
};

const oktaSignInConfig = {
  baseUrl: process.env.REACT_APP_OKTA_BASE_URL,
  clientId: process.env.REACT_APP_OKTA_CLIENTID,
  redirectUri: window.location.origin + '/login/callback',
  issuer:  process.env.REACT_APP_OKTA_BASE_URL + '/oauth2/' + process.env.REACT_APP_OKTA_AUTH_SERVER_ID,
  authParams: {
    // If your app is configured to use the Implicit Flow
    // instead of the Authorization Code with Proof of Code Key Exchange (PKCE)
    // you will need to uncomment the below line
    // pkce: false
  },
  scopes: ['openid','profile','email']
};

export { oktaAuthConfig, oktaSignInConfig };